import api from '../../utils/api'

export const state = {
  partnerReferrals: [],
  partnerReferral: {
    name: '',
    description: '',
    logoUrl: '',
    benefitLabel: 'Benefício parceiro',
    benefitCondition: '',
    redeemPhone: '',
    isActive: true,
    _id: ''
  }
}

export const mutations = {
  SET_PARTNER_REFERRALS(state, partnerReferrals) {
    state.partnerReferrals = partnerReferrals
  },
  SET_PARTNER_REFERRAL(state, partnerReferral) {
    state.partnerReferral = partnerReferral
  }
}

export const actions = {
  async getActivePartnerReferrals({ commit }) {
    const { data } = await api.get('/partner-referrals')
    commit('SET_PARTNER_REFERRALS', data)
    return data
  },
  async getPartnerReferrals({ commit }) {
    const { data } = await api.get('/admin/partner-referrals')
    commit('SET_PARTNER_REFERRALS', data)
    return data
  },
  async handleCreatePartnerReferral({ state }) {
    const { data } = await api.post('/admin/partner-referrals', state.partnerReferral)
    return data
  },
  async handleUpdatePartnerReferral({ state }, _id) {
    const { data } = await api.put(`/admin/partner-referrals/${_id}`, state.partnerReferral)
    return data
  },
  async handleDeletePartnerReferral(_, _id) {
    const { data } = await api.delete(`/admin/partner-referrals/${_id}`)
    return data
  },
  setPartnerReferral({ commit }, partnerReferral) {
    commit('SET_PARTNER_REFERRAL', partnerReferral)
  },
  resetPartnerReferral: ({ commit }) => commit('SET_PARTNER_REFERRAL', {
    name: '',
    description: '',
    logoUrl: '',
    benefitLabel: 'Benefício parceiro',
    benefitCondition: '',
    redeemPhone: '',
    isActive: true,
    _id: ''
  })
}

export const getters = {
  partnerReferrals: (state) => state.partnerReferrals,
  partnerReferral: (state) => state.partnerReferral
}
